import React from 'react';
import '../styles/index.css';

import {
  CssBaseline,
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core';
import { dialColor } from '../styles/colors';

import MapProvider from '../contexts/MapProvider';

import AppContainer from '../containers/AppContainer';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      light: '#fff',
      main: dialColor,
      dark: '#000',
    },
    secondary: {
      main: dialColor,
    },
  },
  typography: {
    fontFamily: '"Poppins", "Arial", sans-serif',
    fontSize: 12,
    fontWeightLight: 600,
    fontWeightRegular: 600,
    fontWeightMedium: 600,
  },
});

const Index = () => (
  <MapProvider>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <AppContainer />
    </MuiThemeProvider>
  </MapProvider>
);

export default Index;
